import {
  Directive,
  ElementRef,
  Input,
  TemplateRef,
  ViewContainerRef
} from '@angular/core';
import { AuthService } from './auth.service';

// eslint-disable-next-line @angular-eslint/directive-selector
@Directive({ selector: '[hasPermission]' })
export class RolePermissionDirective {
  private currentUser;
  private permissions = [];

  constructor(
    private element: ElementRef,
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private auth: AuthService
  ) {}

  @Input()
  set hasPermission(val) {
    this.permissions = val;
    this.updateView();
  }

  private updateView() {
    if (this.checkPermission()) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }

  private checkPermission() {
    if (Array.isArray(this.permissions)) {
      for (const checkPermission of this.permissions) {
        const permissionFound = this.auth.checkRolePermission(checkPermission);
      }
    } else {
      return this.auth.checkRolePermission(this.permissions);
    }
  }
}
